import PUWVehicleDetailsView from 'text!../views/puw-vehicle-details.html';
import PUWVehicleDetailsCtrl from '../controllers/PUWVehicleDetailsCtrl';
import PUWSummaryView from 'text!../views/puw-summary.html';
import PUWSummaryCtrl from '../controllers/PUWSummaryCtrl';
import PUWConfirmationView from 'text!../views/puw-confirmation.html';
import PUWConfirmationCtrl from '../controllers/PUWConfirmationCtrl';
import QuoteDetailsView from 'text!edge/quoteandbind/common/views/quote-details.html';
import QuoteDetailsCtrl from 'edge/quoteandbind/common/controllers/QuoteDetailsCtrl';
import PUWDeliveryDateView from 'text!../views/puw-delivery-date-setting.html';
import PUWDeliveryDateCtrl from '../controllers/PUWDeliveryDateSettingCtrl';
import PUWRedWireView from 'text!../views/puw-red-wire-setting.html';
import PUWRedWireCtrl from '../controllers/PUWRedWireCtrl';
import PUWReportView from 'text!../views/puw-report.html';
import PUWReportCtrl from '../controllers/PUWReport';
import PUWCommercialReportView from 'text!../views/puw-commercial-dealer-report.html';
import PUWCommercialReportCtrl from '../controllers/PUWCommercialReportCtrl';
import PUWBillingReportView from 'text!../views/puw-billing-dealer-report.html';
import PUWBillingReportCtrl from '../controllers/PUWBillingReportCtrl';
import PUWClaimReportView from 'text!../views/puw-claim-dealer-report.html';
import PUWClaimReportCtrl from '../controllers/PUWClaimReportCtrl';


export default (RootStates) => {
    const wizardParentState = 'baseTransactionWizard';
    const parentState = RootStates.main_root;
    return {
        puwVehicleDetails: {
            name: 'puwVehicleDetails',
            parent: wizardParentState,
            controller: PUWVehicleDetailsCtrl,
            template: PUWVehicleDetailsView
        },
        // Quote screen is OOTB. Added here to avoid jumping from PUW to Common to PUW to Common, etc.
        // So now it is possible to read and to understand
        puwQuoteDetails: {
            name: 'puwQuoteDetails',
            parent: wizardParentState,
            controller: QuoteDetailsCtrl,
            template: QuoteDetailsView
        },
        puwSummary: {
            name: 'puwSummary',
            parent: wizardParentState,
            controller: PUWSummaryCtrl,
            template: PUWSummaryView
        },
        puwConfirmation: {
            name: 'puwConfirmation',
            parent: wizardParentState,
            controller: PUWConfirmationCtrl,
            template: PUWConfirmationView
        },
        PUWDeliveryDateSetting: {
            name: 'PUWDeliveryDateSetting',
            parent: parentState,
            url: '/puw-delivery-date-setting/',
            template: PUWDeliveryDateView,
            controller: PUWDeliveryDateCtrl,
            data: {
                // actions: {
                //     next: 'newQuote'
                // }
            }
        },
        PUWRedWireSetting: {
            name: 'PUWRedWireSetting',
            parent: parentState,
            url: '/puw-red-wire-setting/',
            template: PUWRedWireView,
            controller: PUWRedWireCtrl,
            data: {
                // actions: {
                //     next: 'newQuote'
                // }
            }
        },
        PUWReport: {
            name: 'PUWReport',
            parent: parentState,
            url: '/PUWReport/',
            template: PUWReportView,
            controller: PUWReportCtrl,
            data: {
                // actions: {
                //     next: 'newQuote'
                // }
            }
        },
        PUWCommercialReport: {
            name: 'PUWCommercialReport',
            parent: parentState,
            url: '/PUWCommercialReport/',
            template: PUWCommercialReportView,
            controller: PUWCommercialReportCtrl,
            data: {
                // actions: {
                //     next: 'newQuote'
                // }
            }
        },
        PUWBillingReport: {
            name: 'PUWBillingReport',
            parent: parentState,
            url: '/PUWBillingReport/',
            template: PUWBillingReportView,
            controller: PUWBillingReportCtrl
        },
        PUWClaimReport: {
            name: 'PUWClaimReport',
            parent: parentState,
            url: '/PUWClaimReport/',
            template: PUWClaimReportView,
            controller: PUWClaimReportCtrl,
            data: {
                // 
            }
        }
    };
};
